module.exports = __webpack_public_path__ + "static/girallon_zombie-68331f5bc562da7f2a75296cb04a108c.png";